export default {
  searchForm: {
    choseLabel: 'Shops',
    chosePlaceholder: 'Please Select Shop(s)',
    timeLabel: 'Time',
    classLabel: 'Category of Top clicks',
    topLabel: 'Range of Top clicks',
    submitText: 'Submit',
    exportText: 'Download',
    last7: 'Last 7 days',
    last30: 'Last 30 days',
    top30: 'top30',
    top50: 'top50',
    top100: 'top100',
  },
  topTableCard: {
    title: 'Top index ranking of shops',
    columns: {
      country: 'Country/Region',
      shopName: 'Shop',
      opt: 'Index(opt-p)',
      ret: 'Index(ret-p)',
      lineProgress: 'Bar chart',
      value: 'Value',
      skuImg: 'sku占位图',
      commonSku: 'SKU',
    },
  },
  topModal: {
    title: 'Details',
    addTo: 'Add to Favorite',
    image: 'Image',
    name: 'Shop Name',
    brand: 'Brand',
  },
};
